export enum Alignment {
	Horizontal,
	Vertical,
	Tabs
}